import { Scene, ServicesConfig } from "onearm";

import { GameServices } from "./services.config.js";
import { slotDefinition } from "./slotDefinition.config.js";
import { FontStyles } from "./FontStyles.js";

import { HUDScene} from "../scenes/HUDScene.js";
import { AnubisReelsScene } from "../scenes/AnubisReelsScene.js";

import { PreloaderScene } from "../scenes/PreloaderScene.js";

import { NoFundsPopupScene } from "../scenes/popups/NoFundsPopupScene.js";
import { SessionExpiredPopupScene } from "../scenes/popups/SessionExpiredPopupScene.js";
import { SystemSettingsPopupScene } from "../scenes/popups/SystemSettingsPopupScene.js";
import { InfoPopupScene } from "../scenes/popups/InfoPopupScene.js";
import { AutoPlaySettingsScene } from "../scenes/popups/AutoPlaySettingsScene.js";
import { BetSettingsScene } from "../scenes/popups/BetSettingsScene.js";
import { ErrorMessagePopupScene } from "../scenes/popups/ErrorMessagePopupScene.js";
import { WinPopupScene } from "../scenes/popups/WinPopupScene.js";

import { symbolWin } from "../animations/symbolWin.js";
import { paylineAnimation } from "../animations/paylineAnimation.js";
import { characterReaction } from "../animations/characterReaction.js";
import { AnubisCascadeStrategy } from "../animations/AnubisCascadeStrategy.js";


import { PaylinePaysAct } from "../acts/PaylinePaysAct.js";


import { logo } from "../flows/logo.js";

export const GameConfig = {
    gameId: "anubis-slot",
    services: Object.assign({}, { ...ServicesConfig }, { ...GameServices }),
    styles: FontStyles,
    layers: {
        layers: [
            "background",
            "reelsFrame",
            "reels",
            "overReel",
            "paylineLayer",
            "symbolsAnimationLayer",
            "hud",
            "overHud",
            "popups",
        ],
    },
    data: {
        musicVolume: 80,
        sfxVolume: 100,
        volume: 80,
        isSoundsMuted: false,
        isMusicMuted: false,
        isSfxMuted: false,
        spinType: "normal",
        isWinAnimation: true,
        isElementAnimation: true,
        animationSpeed: 50,
    },
    reelsConfig: {
        AnimationStrategy: AnubisCascadeStrategy,
        sceneTimings: {
            spinReelDelay: 0.04,
            stopReelDelay: 0.04,
            quickReelDelay: 0.01,
        },
        strategyOptions: {
            fallDelay: 0.04,
            fallDuration: 0.2,
            dropAnimationDuration: 0.3,
            distanceFactor: 0.02,
            quickFallDelay: 0.01,
            quickDropDuration: 0.14,
            fallEase: "power1.in",
            dropEase: "back.out(1.25)",
            quickDropEase: "back.out(1.15)",
        },
    },
    flow: logo,
    scenes: {
        HUDScene: {
            Scene: HUDScene,
            children: {
                reels_ph: "ReelsScene",
            },
        },
        ReelsScene: AnubisReelsScene,
        PreloaderScene,
        NoFundsPopupScene,
        SessionExpiredPopupScene,
        SystemSettingsPopupScene,
        InfoPopupScene,
        AutoPlaySettingsScene,
        BetSettingsScene,
        ErrorMessagePopupScene,
        WinPopupScene,
    },
    presentationActs: {
        pays: PaylinePaysAct,
    },
    animations: {
        symbolWin,
        paylineAnimation,
        characterReaction,
    },
    ...slotDefinition,
};
